exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2Q1SfOcpjtFLc0Rx3SxR5f{display:flex;flex-direction:column}._2j7HmD5A3XDHGI2wM0cFsP{align-self:center}._3nrDh7bV0xtKVSXU9N9bgE{padding-bottom:20px;display:flex;align-items:center}._1kcd9oVTRxMx1m_ZMavZGw{padding:20px}\n", ""]);

// Exports
exports.locals = {
	"accounts": "_2Q1SfOcpjtFLc0Rx3SxR5f",
	"arrows": "_2j7HmD5A3XDHGI2wM0cFsP",
	"preview": "_3nrDh7bV0xtKVSXU9N9bgE",
	"profileImg": "_1kcd9oVTRxMx1m_ZMavZGw"
};